import { getDefaultLanguage } from "Utils";
import { PAGES, HORIZONTAL } from "Config";
// import _ from "i18n";

// Language reducer
const defaultLanguage = localStorage.getItem("lng") || getDefaultLanguage();
export const languageReducer = (state = defaultLanguage, action) => {
  switch (action.type) {
    case "SET_LANGUAGE": {
      return action.language;
    }
    default:
      return state;
  }
};

// Language reducer
const initialBreadCrumbState = {
  url: null,
  params: []
};
export const breadCrumbReducer = (state = initialBreadCrumbState, action) => {
  switch (action.type) {
    case "INIT_BREAD_CRUMBS": {
      return initialBreadCrumbState;
    }
    case "SET_BREAD_CRUMBS": {
      return action.payload;
    }
    default:
      return state;
  }
};

// SubMenuDirection reducer
export const subMenuDirectionReducer = (state = HORIZONTAL, action) => {
  switch (action.type) {
    case "SET_SUB_MENU_DIRECTION": {
      return action.subMenuDirection;
    }
    default:
      return state;
  }
};

export const subMenuDirectionToggleReducer = (state = true, action) => {
  switch (action.type) {
    case "SET_SUB_MENU_DIRECTION_TOGGLE": {
      return action.subMenuDirectionToggle;
    }
    default:
      return state;
  }
};

// Current Navigation Page Reducer
export const currentNavPageReducer = (state = PAGES.HOME_PAGE, action) => {
  switch (action.type) {
    case "SET_CURRENT_NAV_PAGE": {
      return action.currentNavPage;
    }
    default:
      return state;
  }
};

// App Is Embedded Reducer
export const appIsEmbeddedReducer = (state = false, action) => {
  switch (action.type) {
    case "SET_APP_IS_EMBEDDED": {
      return action.embedded;
    }
    default:
      return state;
  }
};

//SourceToken Reducers
export const sourcesTokensReducer = (state = [], action) => {
  switch (action.type) {
    case "PUSH_SOURCE_TOKEN": {
      let newItem = {
        sourceName: action.sourceName,
        sourceToken: action.sourceToken
      };
      let filtredItem = state.filter(
        item => item.sourceName === action.sourceName
      );
      let mapedItems = state.map(
        item => (item.sourceName === action.sourceName ? newItem : item)
      );
      let tab = [...state, newItem];
      let results = filtredItem.length > 0 ? mapedItems : tab;
      return results;
    }
    case "CLEAR_SOURCES_TOKENS": {
      return [];
    }
    default:
      return state;
  }
};

// SearchLayer reducer
export const visibleSearchLayerReducer = (state = false, action) => {
  switch (action.type) {
    case "SHOW_SEARCH_LAYER": {
      return action.visible;
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/params.js